import script from "./AdminFormElementPin.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementPin.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementPin.vue?vue&type=style&index=0&id=1cf66944&lang=scss"

const __exports__ = script;

export default __exports__